import Elk, { type ElkNode } from 'elkjs/lib/elk.bundled.js'
import { type Direction, type LayoutAlgorithm } from '.'

const elk = new Elk()

function getDirection(direction: Direction) {
  switch (direction) {
    case 'TB':
      return 'DOWN'
    case 'LR':
      return 'RIGHT'
    case 'BT':
      return 'UP'
    case 'RL':
      return 'LEFT'
  }
}

const elkLayout: LayoutAlgorithm = async (nodes, edges, options) => {
  const graph = {
    id: 'elk-root',
    layoutOptions: {
      'elk.algorithm': 'mrtree',
      'elk.direction': getDirection(options.direction),
      'elk.spacing.nodeNode': `${100}`,
    },
    children: nodes.map((node) => ({
      id: node.id,
      width: node.width ?? 0,
      height: node.height ?? 0,
    })),
    edges: edges.map((edge) => ({
      id: edge.id,
      sources: [edge.source],
      targets: [edge.target],
    })),
  }

  const root = await elk.layout(graph)
  const layoutNodes = new Map<string, ElkNode>()
  for (const node of root.children ?? []) {
    layoutNodes.set(node.id, node)
  }

  const nextNodes = nodes.map((node) => {
    const elkNode = layoutNodes.get(node.id)!
    const position = { x: elkNode.x!, y: elkNode.y! }

    return {
      ...node,
      position,
    }
  })

  return { nodes: nextNodes, edges }
}

export default elkLayout
